export default {
    BADeposit: 30,
};
  